// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"Feedback_feedbackContainer__PJZ4R","feedbackBox":"Feedback_feedbackBox__HE3b7"};